const DeckHeader = require('./deck-header');
const CollectionManager = require('../ui/collection');
const UserDeckStore = require('../user/deck-store');
const uievents = require('../ui/events');
const Tracker = require('../navigation/tracker');
const ToggledIntro = require('../ui/toggled-intro');
const template = require('./userdecks.tpl').default;

require('../navigation/anchor');

module.exports = DomClass(template, function UserDecks() {
	var _t = this;

	var tracker = new Tracker();
	var deckShowEventIndex = [];
	this.decks = [];

	this.status = 'Loading ...';

	var manager = new CollectionManager(
		this.decks, this.addform, DeckHeader, UserDeckStore, tracker
	);

	ToggledIntro.call(this.intro, manager);

	on(manager, 'reloading').then(function() {
		_t.status = 'Loading ...';
	});

	on(manager, 'change').then(function() {
		_t.status = 'Saving ...';
	});

	on(manager, 'restore').then(function() {
		_t.status = 'Loaded.';
	});

	on(manager, 'save').then(function() {
		_t.status = 'Saved.';
	});

	on(manager, 'error').then(function() {
		_t.status = 'ERROR SAVING!';
	});

	this.add = function(name) {
		var deck = new DeckHeader({name: name});
		manager.add(deck);
		return deck;
	};

	this.load = function() {
		manager.restore();
	};

});
